export default __webpack_public_path__ + "static/media/ic-loader-large.bd888d20.svg";